<div class="row" *ngIf="spinnerActivo">
  <div class="col-12" *ngIf="tipo === 'spinner'">
    <img [ngStyle]="{'width': ancho, 'height': alto}" src="../../../assets/images/spinner.gif" />
  </div>
</div>